import { Box, Button, Group, List, Modal, Text, Title } from '@mantine/core';
import type { JSX } from 'react';
import type { ConsentDefinition } from '../../lib/constants';

interface RevokeConsentModalProps {
  opened: boolean;
  definitions: ConsentDefinition[];
  onCancel: () => void;
  onConfirm: () => void;
}

export function RevokeConsentModal({ opened, definitions, onCancel, onConfirm }: RevokeConsentModalProps): JSX.Element {
  const multiple = definitions.length > 1;
  return (
    <Modal opened={opened} onClose={onCancel} withCloseButton={false} centered size="lg" radius="lg" padding="xl">
      <Title order={3} ta="center" mb="xs">
        Warning
      </Title>
      <Text size="sm" ta="center" mb="lg">
        Revoking {multiple ? 'these consents' : 'your consent'} will have the following effects:
      </Text>
      <Box bg="gray.0" p="xl" style={{ borderRadius: 'var(--mantine-radius-md)' }}>
        {multiple ? (
          <List spacing="sm" mb="md">
            {definitions.map((d) => (
              <List.Item key={d.key}>
                <Text fw={600} component="span">
                  {d.title}:
                </Text>{' '}
                {d.revokeWarning}
              </List.Item>
            ))}
          </List>
        ) : (
          <Text ta="center" mb="md">
            {definitions[0]?.revokeWarning}
          </Text>
        )}
        <Text ta="center" mb="xl">
          You may give {multiple ? 'these consents' : 'this consent'} again at any time.
        </Text>
        <Group justify="center" gap="md">
          <Button size="lg" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="lg" variant="outline" onClick={onConfirm}>
            Yes, revoke {multiple ? 'my consents' : 'my consent'}
          </Button>
        </Group>
      </Box>
    </Modal>
  );
}
